import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: error?.message || "Erreur inattendue" };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("EDITORIX ErrorBoundary:", error, info);
    try {
      const body = JSON.stringify({
        url: window.location.href,
        message: (error && (error.stack || error.message || String(error))) || "unknown",
        stack: info && info.componentStack ? info.componentStack : "",
      });
      fetch(`${process.env.REACT_APP_BACKEND_URL}/api/client-error`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body,
        keepalive: true,
      }).catch(() => {});
    } catch (e) {}
  }

  reset = () => {
    this.setState({ hasError: false, message: "" });
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="min-h-screen bg-background flex items-center justify-center p-6" data-testid="error-boundary">
        <div className="max-w-md text-center border border-border bg-surface rounded-lg p-10">
          <div className="text-5xl mb-4">⚠️</div>
          <h1 className="font-serif text-2xl mb-2">Une erreur est survenue</h1>
          <p className="text-sm text-muted-foreground mb-6">
            Cette page a rencontré un problème et n'a pas pu s'afficher. Vos données sont en sécurité.
          </p>
          <div className="flex gap-3 justify-center">
            <button
              data-testid="error-reload"
              onClick={() => window.location.reload()}
              className="h-10 px-4 rounded-sm bg-primary text-primary-foreground font-medium hover:opacity-90 transition-opacity"
            >
              Recharger
            </button>
            <button
              data-testid="error-home"
              onClick={() => { this.reset(); window.location.href = "/"; }}
              className="h-10 px-4 rounded-sm border border-border hover:bg-surface-hover transition-colors"
            >
              Retour à l'accueil
            </button>
          </div>
        </div>
      </div>
    );
  }
}
